import { inject, Injectable } from '@angular/core';
import { User, UserPreferences } from './User';
import {
  collection,
  doc,
  docData,
  Firestore,
  updateDoc,
} from '@angular/fire/firestore';
import { AuthService } from 'src/services/auth/auth.service';
import { UserService } from './user.service';
import { BehaviorSubject } from 'rxjs';
import { addDoc, setDoc } from 'firebase/firestore';

@Injectable({
  providedIn: 'root',
})
export class FirestoreUserService implements UserService {
  public user = new BehaviorSubject<User | null>(null);

  firestore: Firestore = inject(Firestore);
  authService: AuthService = inject(AuthService);

  constructor() {
    docData(
      doc(this.firestore, `/users/${this.authService.user?.uid}`)
    ).subscribe((value) => {
      const user = value as User;

      this.authService.hasProOverride = (user as User)?.hasProOverride || false;

      this.user.next(user as User);
    });
  }

  async create(user: User): Promise<void> {
    // TODO: check if it already exists
    await setDoc(
      doc(this.firestore, `/users/${this.authService.user?.uid}`),
      user
    );
  }

  async savePreferredTagOrder(ids: string[]): Promise<void> {
    try {
      await updateDoc(
        doc(this.firestore, `/users/${this.authService.user?.uid}`),
        { tagIdsInPreferredOrder: ids }
      );
      return Promise.resolve();
    } catch (e) {
      if ((e as any).code === 'not-found') {
        await this.create({ tagIdsInPreferredOrder: ids });
        return this.savePreferredTagOrder(ids);
      } else {
        return Promise.reject();
      }
    }
  }

  update(user: User): Promise<void> {
    return updateDoc(
      doc(this.firestore, `/users/${this.authService.user?.uid}`),
      { ...user }
    );
  }
}
